// eslint-disable-next-line no-unused-vars
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
// eslint-disable-next-line no-unused-vars
import { Field, Form } from 'react-final-form';
import {
  DisplaySuccessMessage, // eslint-disable-line no-unused-vars
  DisplayWarningMessage, // eslint-disable-line no-unused-vars
  Loader, // eslint-disable-line no-unused-vars
  useValidationSchema,
  callFxgApi,
  FxComponentWrapper, // eslint-disable-line no-unused-vars
  FxMultiButtons, // eslint-disable-line no-unused-vars
  FxTextLink, // eslint-disable-line no-unused-vars
} from 'axp-fx-common';
import useAutoFocus from '../../../hooks/useAutoFocus';
import { registerFormData } from '../registerFormInitData';
import labels from '../../../constants/labels';
import fields from '../../../constants/fields';
import { apiPaths } from '../../../constants/paths';
import { otpValidationSchema } from '../../../utils/registrationSchemaUtil';
import { steps } from '../../../constants/registration';
import {
  API_SUCCESS_CD,
  OTP_EXPIRED_CD,
  OTP_INVALID_CD,
  OTP_INVALID_MSG,
} from '../../../constants/apiCodes';
import { INTERNAL_SERVER_ERR_MSG } from '../../../constants/constants';

const OTP = (props) => {
  const {
 setRegistrationStep, setErrorData, regId, rsvpCd, setAccountData,
} = props;

  const [showComponentLoader, setShowComponentLoader] = useState(false);
  const [showPageBlockLoader, setPageBlockLoader] = useState(false);
  const [otpErrorData, setOtpErrorData] = useState([]);
  const [otpSuccessData, setOtpSuccessData] = useState([]);

  const otpInput = useAutoFocus();

  const fxgApiHost = useSelector((state) => state.getIn(['config', 'fxgApi']));

  const validateRsvpAndSendOTP = async () => {
    const requestData = {
      regId,
      rsvpCd,
    };
    /* validate RSVP code and fetch user details */
    const { response, hasErrors } = await callFxgApi(
        `${fxgApiHost}${apiPaths.validateRsvpCd}`,
      'POST',
      requestData
    );
    return { response, hasErrors };
  };

  useEffect(() => {
    const sendOtp = async () => {
      setShowComponentLoader(true);
      setOtpErrorData([]);
      setErrorData({});
      const { response, hasErrors } = await validateRsvpAndSendOTP();
      if (!hasErrors && response?.respCd === API_SUCCESS_CD) {
        setAccountData(response?.data);
      } else {
        setOtpErrorData([INTERNAL_SERVER_ERR_MSG]);
      }
      setShowComponentLoader(false);
    };

    sendOtp();
  }, []); // initial OTP send only

  /**
   *
   * @param {*} form
   *
   * 1. This method is to perform resend OTP function
   * 2. set the OTP resend status based on api success/failed
   */
  const validateRsvpAndReSendOTP = async (form) => {
    setPageBlockLoader(true);
    setOtpSuccessData([]);
    setOtpErrorData([]);
    form.reset('otp');
    form.focus('otp');
    const { response, hasErrors } = await validateRsvpAndSendOTP();
    if (!hasErrors && response?.respCd === API_SUCCESS_CD) {
      setOtpSuccessData(['OTP sent successfully']);
    } else {
      setOtpErrorData(['Error sending OTP. Please try again']);
    }
    setPageBlockLoader(false);
  };

  /**
   *
   * @param {*} formValues
   * @returns
   *
   * This method is to validate the OTP entered by the user on click of submit button
   * 1. If the OTP validation is success, update the registration step to success
   * 2. If the OTP is invalid/expired, display error message to the OTP field
   * 3. Other than invalid/expired error, display registration error detail
   */
  const validateOTP = async (formValues) => {
    setOtpErrorData([]);
    setPageBlockLoader(true);
    const requestData = {
      otp: formValues.otp,
      regId,
      rsvpCd,
    };
    const { response, hasErrors } = await callFxgApi(
      `${fxgApiHost}${apiPaths.validateOTP}`,
      'POST',
      requestData
    );
    setPageBlockLoader(false);
    if (!hasErrors && response?.respCd === API_SUCCESS_CD) {
      setRegistrationStep(steps.ACCOUNT);
    } else if ([OTP_INVALID_CD, OTP_EXPIRED_CD].includes(response?.errorCd)) {
      return { otp: OTP_INVALID_MSG };
    } else {
      setOtpErrorData([INTERNAL_SERVER_ERR_MSG]);
    }

    return null;
  };

  // reset success data after 3 seconds.
  useEffect(() => {
    if (otpSuccessData?.length > 0) {
      setTimeout(() => {
        setOtpSuccessData([]);
      }, 3000);
    }
  }, [otpSuccessData]);

  /* check if the form values are invalid */
  const isFormInvalid = (form) => {
    const fieldsWithErrors = Object.keys(form.getState()?.errors);
    const isInvalid = fieldsWithErrors?.includes(fields.otp);
    return isInvalid;
  };

  const handleOtpChange = (event, form) => {
    const otpRegex = /^[\d\b]+$/; // match only numbers
    if (event.target.value === '' || otpRegex.test(event.target.value)) {
      form.change('otp', event.target.value);
    }
  };

  const handleOtpCancelButtonClick = () => {
    window.location.reload();
  };

  const validate = useValidationSchema(otpValidationSchema);

  return (
    <FxComponentWrapper
      isLoading={showComponentLoader}
      loadedComponent={(
        <Form
          validate={validate}
          onSubmit={(formValues) => validateOTP(formValues)}
          debug={(state, fieldStates) => console.log(state, fieldStates)}
          initialValues={{ otp: '' }}
          render={({ handleSubmit, form }) => (
            <form onSubmit={handleSubmit}>
              <Loader showLoader={showPageBlockLoader} />

              {otpErrorData.length > 0 && (
                <DisplayWarningMessage messageDataList={otpErrorData} />
              )}

              {otpSuccessData.length > 0 && (
              <DisplaySuccessMessage messageDataList={otpSuccessData} />
              )}

              <Field
                {...registerFormData.otp}
                handleOnChange={(event) => handleOtpChange(event, form)}
                autoFocus="autoFocus"
                ref={otpInput}
                maxLength="6"
              />

              <div className="margin-1-t">
                <FxTextLink
                  text="Didn't receive a code? Resend"
                  onTextClick={() => validateRsvpAndReSendOTP(form)}
                />
              </div>

              <div className="margin-4-t">
                <FxMultiButtons
                  primaryButtonLabel={labels.VALIDATE}
                  isDisablePrimaryButton={isFormInvalid(form)}
                  secondaryButtonLabel={labels.CANCEL}
                  onSecondaryButtonClick={handleOtpCancelButtonClick}
                  justifyButtons="end"
                />
              </div>
            </form>
          )}
        />
      )}
    />
  );
};

OTP.propTypes = {
  setRegistrationStep: PropTypes.func.isRequired,
  setErrorData: PropTypes.func.isRequired,
  regId: PropTypes.string.isRequired,
  rsvpCd: PropTypes.string.isRequired,
  setAccountData: PropTypes.func.isRequired,
};

export default OTP;
